import { stringToBoolean } from "../common/shared/methods";

// access process.env properties from the client, props get attached to `window.env`
export const runtimeConfig =
  typeof window !== 'undefined'
    ? {
      // client
      apiRoot: window.env.apiRoot,
      webRoot: window.env.webRoot,
      mockData: window.env.MOCKDATA,
      csatId: window.env.csatId,
      qmtUrl: window.env.qmtUrl,
      qmtLoadUrl: window.env.qmtLoadUrl,
      typeformLoadUrl: window.env.typeformLoadUrl,
      psEnv: window.env.psEnv,
      psKey: window.env.psKey,
      psUrl: window.env.psUrl,
      touVersion: window.env.touVersion,
      blobUrl: window.env.blobUrl,
      csPhone: window.env.csPhone,
      csEmail: window.env.csEmail,
      evBlob: window.env.evBlob,
      apiKey: window.env.apiKey,
      ukCsEmail: window.env.ukCsEmail,
      caCsEmail: window.env.caCsEmail,
      qmtMrktPlcUrl: window.env.qmtMrktPlcUrl,
      taxFeatureFlag: stringToBoolean(window.env.taxFeatureFlag || 'true')
    }
    : {
      // server
      apiRoot: process.env.RAZZLE_RUNTIME_API_ROOT || '',
      webRoot: process.env.RAZZLE_RUNTIME_WEB_ROOT || '',
      mockData: process.env.MOCKDATA || '',
      csatId: process.env.CSAT_SURVEY_ID || '',
      qmtUrl: process.env.QMT_URL || '',
      qmtLoadUrl: process.env.QMT_LOAD_URL || '',
      typeformLoadUrl: process.env.TYPEFORM_LOAD_URL || '',
      psEnv: process.env.PAYSTAND_ENV || '',
      psKey: process.env.PAYSTAND_PUBLISH_KEY || '',
      psUrl: process.env.PAYSTAND_SCRIPT_URL || '',
      touVersion: process.env.TOU_VERSION || '',
      blobUrl: process.env.BLOB_URL || '',
      csPhone: process.env.CS_PHONE || '',
      csEmail: process.env.CS_EMAIL || '',
      evBlob: process.env.EV_BLOB || '',
      pKey: process.env.STRIPE_PUBLIC_KEY || '',
      apiKey: process.env.API_KEY || '',
      ukCsEmail: process.env.UK_CS_EMAIL || '',
      caCsEmail: process.env.CA_CS_EMAIL || '',
      qmtMrktPlcUrl: process.env.QMT_MRKTPLC_URL || '',
      taxFeatureFlag: stringToBoolean(process.env.TAX_FEATURE_FLAG || 'true')
    };
